module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11452/img/callout-wave.svg"